import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { getEntityById } from '../../utils/DataAccessUtils';
import {
	contractorLocationsRestCrudThunksForBuyer,
	contractorLocationsRestCrudThunksForSupplier,
} from '../../thunks/contractor_locations_thunks';
import ContractorLocationForm from './ContractorLocationForm';

const EditContractorLocationsPage: React.FC<any> = ({
	match,
	getLocation,
	contractorLocation,
	history,
	fetching,
}): React.ReactElement => {
	const locationId = match.params.id;

	useEffect(() => {
		getLocation(locationId);
	}, []);

	return (
		<>
			<EditPage
				title="Edit Location"
				formComponentProps={{
					formData: contractorLocation,
					onSuccess: (rec) => history.goBack(),
				}}
				fetching={fetching}
				FormComponent={ContractorLocationForm}
			/>
			,
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	contractorLocation: getEntityById(ownProps.match.params.id, state.contractor_locations),
	fetching: state.contractor_locations.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getLocation: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? contractorLocationsRestCrudThunksForSupplier.readOne(id)
				: contractorLocationsRestCrudThunksForBuyer.readOne(id)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditContractorLocationsPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
